import { action, computed, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../api/RemoteResourceV3';
import { LocationApis } from '../../mainv3/apis/locations';

export class BaseListState {
    @observable bases = RemoteResourceV3.loading();

    @action.bound
    async init() {
        await updateRemoteResourceV3(this.bases, (v) => (this.bases = v), () => LocationApis.findAllBases());
    }

    @computed
    get loading() {
        return this.bases.loading;
    }

    @computed
    get baseList() {
        return this.bases.getOrElse([]);
    }
}
